import AccessCommander2NConfigPageView from "./AccessCommander2NConfigsPageView";
import { useState } from "react";
import { useRouteContext } from "../../../../context/RouteContext";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import useCustomEffect from "../../../../hooks/useCustomEffect";

function AccessCommander2NConfigsPage() {
  const routeContext = useRouteContext();
  const callEvaApi = useEvaApi();
  const [accessCommander2NConfigData, setAccessCommander2NConfigData] = useState({
    pincode: false,
    active: false,
  });
  const [submitError, setSubmitError] = useState(null);

  /**
   * Initialize the component
   */
  useCustomEffect(() => {
    fetchAccessCommander2NConfigData();
  });

  /**
   * This method will fetch the access commander 2N config data from the API
   */
  async function fetchAccessCommander2NConfigData() {
    await callEvaApi(
      new EvaApiCall("integrations/access_commander/configs")
        .setLoadingGroup("access_commander_2n_configs_page_fetch")
        .setOnSuccess((response) => {
          const newConfig = response.data.data;
          setAccessCommander2NConfigData({
            pincode: newConfig?.pincode || false,
            active: newConfig?.active || false,
          });
        })
        .setRedirectOnError(true)
    );
  }

  /**
   * This method will handle the onCancel functionality
   */
  function onCancel() {
    routeContext.back();
  }

  /**
   * This method will update the active on input change
   * @param {*} value
   */
  function onActiveChange(value) {
    setAccessCommander2NConfigData({ ...accessCommander2NConfigData, active: value })
  }

  /**
   * This method will update the pincode on input change
   */
  function onPincodeChange() {
    setAccessCommander2NConfigData((prev) => ({ 
      ...prev,
      pincode: !prev.pincode
    }));
  }

  /**
   * This method will handle the submit functionality
   */
  async function onSubmit() {
    await callEvaApi(
      new EvaApiCall("integrations/access_commander/configs")
        .setMethod("PUT")
        .setData(accessCommander2NConfigData)
        .setErrorState(setSubmitError)
        .setRedirectOnSuccess(true)
        .setLoadingGroup("access_commander_2n_configs_page_save")
    );
  }

  return (
    <AccessCommander2NConfigPageView 
      accessCommander2NConfigData={accessCommander2NConfigData}
      onPincodeChange={onPincodeChange}
      onActiveChange={onActiveChange}
      onCancel={onCancel} 
      onSubmit={onSubmit}  
      submitError={submitError}
    />
  );
}

export default AccessCommander2NConfigsPage;